import { render, staticRenderFns } from "./contentsListing.vue?vue&type=template&id=82380d84&scoped=true&"
import script from "./contentsListing.vue?vue&type=script&lang=js&"
export * from "./contentsListing.vue?vue&type=script&lang=js&"
import style0 from "./contentsListing.vue?vue&type=style&index=0&id=82380d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82380d84",
  null
  
)

export default component.exports